import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrSdkModule } from '@bloomreach/ng-sdk';
import {
  AccordionModule as EdsAccordionModule,
  GridModule,
  SpacingModule,
  TitleModule,
} from '@frk/eds-components';
import { PipesModule } from '@shared/pipes/pipes.module';

import { AccordionComponent } from './accordion.component';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { TextBlockModule } from '@marketing/content-blocks/text-block/text-block.module';
import { TitleBlockModule } from '@marketing/content-blocks/title-block/title-block.module';
import { ImageBlockModule } from '@marketing/content-blocks/image-block/image-block.module';
import { OneColBlockModule } from '@marketing/content-blocks/one-col-block/one-col-block.module';
import { TwoColBlockModule } from '@marketing/content-blocks/two-col-block/two-col-block.module';

// Components
@NgModule({
  declarations: [AccordionComponent],
  imports: [
    BrSdkModule,
    CommonModule,
    EdsAccordionModule,
    GridModule,
    SpacingModule,
    PipesModule,
    TitleModule,
    TextBlockModule,
    TitleBlockModule,
    ImageBlockModule,
    OneColBlockModule,
    TwoColBlockModule,
  ],
  exports: [AccordionComponent],
  entryComponents: [AccordionComponent],
  providers: [],
})

/**
 * Accordion Module
 */
export class AccordionModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      Accordion: AccordionComponent,
    };
  }
}
